import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { VisitorTicketDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/visitor-ticket-dialog/visitor-ticket-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { VisitorTickets } from 'src/app/models/tickets';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';

@Component({
  selector: 'app-visitor-analytics-container',
  templateUrl: './visitor-analytics-container.component.html',
  styleUrls: ['./visitor-analytics-container.component.scss'],
})
export class VisitorAnalyticsContainerComponent {
  @Input() set analyticsData(val: IAnalyticsState) {
    if (val) {
      this.monthlyVisitorBarGraph = val.monthlyVisitorBarGraph;
      this.monthlyVisitorInOutGraph = val.monthlyVisitorInOutGraph;
      this.uniqueVisitors = val.uniqueVisitors;
      this.currentDayVisitors = val.currentDayVisitors;
      this.criticalRiskHour = this.riskHourSpan[val.hotCheckInSlot];
    }
  }
  @Output() createVisitorTicket = new EventEmitter<any>();
  visitorTickets: VisitorTickets[];
  screenSize: ScreenType;
  monthlyVisitorBarGraph: any;
  monthlyVisitorInOutGraph: any;
  uniqueVisitors: number = 0;
  criticalRiskHour: string = null;
  currentDayVisitors: number = 0;
  riskHourSpan: string[] = [
    '00:00-02:00',
    '02:00-04:00',
    '04:00-08:00',
    '08:00-10:00',
    '10:00-12:00',
    '12:00-14:00',
    '14:00-16:00',
    '16:00-18:00',
    '18:00-20:00',
    '20:00-22:00',
    '22:00-24:00',
  ];
  profilePic = localStorage.getItem('ProfilePic')
    ? localStorage.getItem('ProfilePic')
    : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';
  constructor(
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  onAddTicket() {
    const dialogRef = this.dialog.open(VisitorTicketDialogComponent, {
      disableClose: true,
      data: '',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.createVisitorTicket.emit(result);
      }
    });
  }
  getFormatedDateTime(val: string) {
    let formatedDate = moment(val, 'YYYY-MM-DDTHH:mm:ss.SSS').fromNow();
    return formatedDate;
  }
  ScreenType = ScreenType;
}
